import { render, staticRenderFns } from "./academy_students.vue?vue&type=template&id=6d8e9f3b&scoped=true"
import script from "./academy_students.vue?vue&type=script&lang=js"
export * from "./academy_students.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8e9f3b",
  null
  
)

export default component.exports